import '@hotwired/turbo-rails'
import './application/stimulus'
import './application/utils/tippy-tooltip'
import { restoreScroll } from './application/utils/scroll'
import * as CookieConsent from 'vanilla-cookieconsent'

window.CookieConsent = CookieConsent

document.addEventListener('turbo:load', restoreScroll)
